import { cn } from "@newxsystems/shared";
import { VelvetAction } from "../VelvetAction/VelvetAction";
import { VelvetMedia } from "../VelvetMedia/VelvetMedia";
import { VelvetRichText } from "../VelvetRichText/VelvetRichText";
import type { ICallToActionStackedProps } from "./CallToActionStacked.props";

const widths = { small: "max-w-md", medium: "max-w-2xl", large: "max-w-4xl" } as const;

export const CallToActionStacked = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionStackedProps) => {
  const centered = alignment === "center";
  return (
    <div
      className={cn(
        "relative flex flex-col gap-7 px-5 md:px-10",
        centered && "items-center text-center",
      )}
    >
      {eyebrow ? (
        <p className="velvet-datum font-velvet-body text-base italic text-thread">{eyebrow}</p>
      ) : null}
      {image ? (
        <VelvetMedia
          aspectRatio={image.aspectRatio || "16:9"}
          className={cn(
            "velvet-arch my-4 w-full border border-parchment/20",
            widths[imageWidth || "medium"],
          )}
          media={image.image}
          sizes="(min-width: 1024px) 70vw, 100vw"
        />
      ) : null}
      {heading ? (
        <h2 className="max-w-[13ch] font-velvet-display text-6xl font-black uppercase leading-[0.82] tracking-[-0.04em] [overflow-wrap:anywhere] md:text-8xl">
          {heading}
        </h2>
      ) : null}
      {description ? (
        <VelvetRichText className="max-w-[65ch] text-bone" content={description} />
      ) : null}
      {buttons?.length ? (
        <div className={cn("flex flex-wrap gap-x-6 gap-y-3 pt-3", centered && "justify-center")}>
          {buttons.map((button, index) => (
            <VelvetAction action={button} className="border-bone" key={`${button.href}-${index}`} />
          ))}
        </div>
      ) : null}
    </div>
  );
};

CallToActionStacked.displayName = "Content::CallToActionStacked";
